import React from 'react';
import { connect } from 'react-redux';

import { Modal } from 'redpoints-front-components/index';

import {
  auditResultsClearCompleted,
  auditResultsSetAppliedAuditorAssetId,
} from '../../../actions/auditResultsActions';
import { getAuditResultsSelectedAuditorAssetId } from '../../../reducers/assetAudit/auditResults';
import { translate } from '../../../helpers/languageHelper';

const ModalContent = () => (
  <div>
    <p>{translate('auditResults.modals.saveAudit.body')}</p>
    <p>{translate('common.doYouWantToContinue')}</p>
  </div>
);

const AuditResultsSaveAuditModal = ({
  auditResultsClearCompleted,
  auditResultsSetAppliedAuditorAssetId,
  closeModal,
  selectedAuditorAssetId,
  visible,
}) => {
  const handleOnCancel = () => {
    closeModal();
    auditResultsClearCompleted();
  };

  const handleOnOk = () => {
    auditResultsSetAppliedAuditorAssetId({
      assetId: selectedAuditorAssetId,
    });
    closeModal();
  };

  return (
    <Modal
      visible={visible}
      okText={translate('actions.save')}
      cancelText={translate('actions.cancel')}
      onOk={handleOnOk}
      onCancel={handleOnCancel}
      closable={false}
      title={translate('auditResults.modals.saveAudit.title')}
    >
      <ModalContent />
    </Modal>
  );
};

const mapStateToProps = state => ({
  selectedAuditorAssetId: getAuditResultsSelectedAuditorAssetId(state),
});

export default connect(mapStateToProps, {
  auditResultsClearCompleted,
  auditResultsSetAppliedAuditorAssetId,
})(AuditResultsSaveAuditModal);
